import { render, staticRenderFns } from "./BulkProfileList.vue?vue&type=template&id=4ec5c426&scoped=true&"
import script from "./BulkProfileList.vue?vue&type=script&lang=ts&"
export * from "./BulkProfileList.vue?vue&type=script&lang=ts&"
import style0 from "./BulkProfileList.vue?vue&type=style&index=0&id=4ec5c426&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec5c426",
  null
  
)

export default component.exports